/* eslint-disable no-underscore-dangle */
import React, { useState } from "react";

// mui table
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { FaRegFileAlt, FaRegFileImage } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setHtmlContent } from "../../features/redux/statusFileSlice";
import { fetchOrderFile } from "../../features/action/fetchStatusFile";
import { ShowOrder } from "../common/ShowOrder";
import { ShowImgStatus } from "../common/ShowImgStatus";
import { getImageStatusFileFetch } from "../../features/action/fetchImage";


function TableList({ data }) {
  const { htmlContent } = useSelector((state) => state.orderFile);
  const { imgStatus, loadingImage } = useSelector((state) => state.imageFile);
  const [showItems, setShowItems] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const dispatch = useDispatch();

  const handleOpenImage = (key, url) => {
    setShowItems(key);
    dispatch(getImageStatusFileFetch(url));
  };

  const handleOpenOrder = (key, numOrder) => {
    setShowOrder(key);
    dispatch(setHtmlContent(null));
    dispatch(fetchOrderFile(numOrder));
  };

  return (
    <TableContainer component={Paper} className="shadow-md h-[350px] overflow-auto">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className="font-semibold">Order Id</TableCell>
            <TableCell className="font-semibold">Client</TableCell>
            <TableCell className="font-semibold">Manager</TableCell>
            <TableCell className="font-semibold">Designer</TableCell>
            <TableCell className="font-semibold">Order List</TableCell>
            <TableCell className="font-semibold">Foto</TableCell>
            <TableCell className="font-semibold">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(
            (row, key) =>
              !row.end && (
                <TableRow key={row._id}>
                  <TableCell
                    component="th"
                    scope="row"
                    className="font-semibold"
                  >
                    <div className="flex items-center">
                      {/* <img src={row.image} alt="product" className="h-9 w-9 object-cover rounded-full mr-2.5" /> */}
                      {row.order}
                    </div>
                  </TableCell>
                  <TableCell className="font-semibold">
                    <span
                      title={
                        row.client
                          ? Array.isArray(row.client)
                            ? row.client.join(", ")
                            : row.client
                          : "No client"
                      }
                    >
                      {row.client
                        ? Array.isArray(row.client) && row.client.length > 0
                          ? row.client[0].substring(0, 10) +
                            (row.client[0].length > 10 ? "..." : "")
                          : typeof row.client === "string"
                          ? row.client.substring(0, 10) +
                            (row.client.length > 10 ? "..." : "")
                          : "No client"
                        : "No client"}
                    </span>
                  </TableCell>
                  <TableCell className="font-semibold">{row.manager}</TableCell>
                  <TableCell className="font-semibold">
                    {row.designer}
                  </TableCell>
                  <TableCell className="font-semibold">
                    <button
                      className="text-[1vw] text-[#dbdbdb]  content-center "
                      onClick={() => handleOpenOrder(key, row.order)}
                    >
                      {<FaRegFileAlt />}
                      {showOrder === key && (
                        <ShowOrder
                          setShowOrder={setShowOrder}
                          htmlContent={htmlContent}
                        />
                      )}
                    </button>
                  </TableCell>
                  <TableCell className="font-semibold">
                    <button
                      className="text-[1vw] text-[#dbdbdb]  content-center "
                      onClick={() => handleOpenImage(key, row.img)}
                    >
                      {row.img && <FaRegFileImage />}
                      {showItems === key && (
                        <ShowImgStatus
                          url={imgStatus}
                          setShowItems={setShowItems}
                          loadingImage={loadingImage}
                        />
                      )}
                    </button>
                  </TableCell>
                  <TableCell className="font-semibold">
                      {row.studio.inWork && <div className="text-blue-500">In Work</div>}
                      {row.studio.print && <div className="text-purple-500">Print</div>}
                      {row.studio.ready && <div className="text-green-600">Ready</div>}
                      {row.studio.rip && <div className="text-orange-500">Rip</div>}
                      {row.studio.sewing && <div className="text-yellow-500">Sewing</div>}
                   
                  </TableCell>
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TableList;
